import { z } from 'zod';
import { PAGINATION } from '../constants/pagination.js';

/**
 * UUID validation
 */
export const uuidSchema = z.string().uuid();

/**
 * Pagination query params
 */
export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).optional().default(PAGINATION.DEFAULT_PAGE),
  limit: z.coerce.number().int().min(1).max(PAGINATION.MAX_LIMIT).optional().default(PAGINATION.DEFAULT_LIMIT),
});

/**
 * ID param for routes like /resource/:id
 */
export const idParamSchema = z.object({
  id: uuidSchema,
});

/**
 * ID and sub-resource ID params for routes like /resource/:id/subresource/:subId
 */
export const idAndFileIdParamSchema = z.object({
  id: uuidSchema,
  fileId: uuidSchema,
});

export const idAndLinkIdParamSchema = z.object({
  id: uuidSchema,
  linkId: uuidSchema,
});

/**
 * Common string constraints
 */
export const nameSchema = z.string().min(1).max(100).trim();
export const notesSchema = z.string().max(2000).trim().nullable().optional();

/**
 * Color hex validation (e.g., #FF5733)
 */
export const colorHexSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/).nullable().optional();

/**
 * Lightweight flag for dropdown/select use cases
 * When true, only returns id + name and allows higher limit
 */
export const lightweightFlagSchema = z.object({
  lightweight: z.coerce.boolean().optional().default(false),
});
